import { useCallback, useEffect } from "react";

import { useFormPageContext } from "../ParticipativeModule/FormPageContext";

// Hides or shows the form page's action bar (submit buttons) based on `visible`.
// The action bar must be hidden while suggestions are pending review so the user
// cannot submit their contribution before acknowledging the similar answers.
export const useFormPageActionsVisibility = visible => {
  // The form page context is only available in the context of a FormPage, and this hook
  // is also used in users subscription form contexts that don't have a parent FormPage.
  const { formActionsContainerRef } = useFormPageContext() || {};

  // Wrapped in useCallback so the reference is stable across renders, keeping it safe
  // to list as a useEffect dependency without causing infinite re-runs.
  const setVisibility = useCallback(
    isVisible => {
      if (!formActionsContainerRef?.current) return;

      if (isVisible) {
        formActionsContainerRef.current.classList.remove("d-none");
      } else {
        formActionsContainerRef.current.classList.add("d-none");
      }
    },
    [formActionsContainerRef]
  );

  useEffect(() => {
    setVisibility(visible);
  }, [visible, setVisibility]);
};
